var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type, Transform, Exclude } from 'class-transformer';
import moment from 'moment';
import { SecurityIOCFeedsFeedTypes as FeedTypes, SecurityIOCFeedsSyncStatus as FeedStatuses, SecurityIOCFeedsErrorCode as ErrorCodes, SecurityIOCFeedsFeedFormat as FeedFormat, } from '@logz-pkg/enums';
class PrivateFeedSettings {
    method;
    headers;
    body;
}
class ErrorDetails {
    code = ErrorCodes.INTERNAL_ERROR;
    message = '';
    suggestedFix = '';
}
export class ThreatsFeedModel {
    id;
    name;
    description;
    sourceUrl;
    iocType;
    iocCount;
    format = FeedFormat.SAWMILL_PIPELINE;
    feedType = FeedTypes.LOGZIO;
    syncStatus = FeedStatuses.ACTIVE;
    confidence;
    lastSuccessfulRun;
    privateFeedSettings = new PrivateFeedSettings();
    errorDetails;
}
__decorate([
    Exclude({ toPlainOnly: true }),
    __metadata("design:type", String)
], ThreatsFeedModel.prototype, "feedType", void 0);
__decorate([
    Exclude({ toPlainOnly: true }),
    __metadata("design:type", String)
], ThreatsFeedModel.prototype, "syncStatus", void 0);
__decorate([
    Exclude({ toPlainOnly: true }),
    Type(() => Date),
    Transform(value => moment(value * 1000), { toClassOnly: true }),
    __metadata("design:type", Object)
], ThreatsFeedModel.prototype, "lastSuccessfulRun", void 0);
__decorate([
    Type(() => PrivateFeedSettings),
    __metadata("design:type", PrivateFeedSettings)
], ThreatsFeedModel.prototype, "privateFeedSettings", void 0);
__decorate([
    Exclude({ toPlainOnly: true }),
    __metadata("design:type", ErrorDetails)
], ThreatsFeedModel.prototype, "errorDetails", void 0);
//# sourceMappingURL=threats-feed.js.map